import type { HomePageLocaleContent } from '../types'

export const homePageEs: HomePageLocaleContent = {
  seoTitle: 'Calcula. Convierte. Hazlo rapido. | Toolvance',
  seoDescription: 'Calculadoras, convertidores y herramientas utiles para la vida diaria, el trabajo, el estudio y la ingenieria.',
  ogDescription: 'Calculadoras gratuitas de ingenieria para calculos electricos, mecanicos, termicos, energeticos y de fisica.',
  tagline: 'Calcula. Convierte. Hazlo rapido.',
  searchPlaceholder: "Buscar - prueba con 'bateria', 'torque', 'ohm'...",
  searchButton: 'Buscar',
  searchResultsPrefix: 'Resultados para',
  resultNounSingular: 'calculadora',
  resultNounPlural: 'calculadoras',
  noResults: 'No se encontraron calculadoras. Prueba con otro termino.',
  popularHeading: 'Calculadoras Populares',
  viewAllPrefix: 'Ver todas las de',
}
